var map = {
	"./de": [
		"fd06",
		"i18n-lang-de"
	],
	"./de.js": [
		"fd06",
		"i18n-lang-de"
	],
	"./en": [
		"5667"
	],
	"./en.js": [
		"5667"
	],
	"./ja": [
		"7f21",
		"i18n-lang-ja"
	],
	"./ja.js": [
		"7f21",
		"i18n-lang-ja"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "9e08";
module.exports = webpackAsyncContext;